import { Colors } from "@/constants/theme";
import { StyleSheet, useColorScheme, View } from "react-native";
import { ThemedText } from "../themed-text";

interface InfoRowProps {
  label: string;
  value: string;
  isLast?: boolean;
}

const InfoRow = ({ label, value, isLast }: InfoRowProps) => {
  const colorScheme = useColorScheme();
  const theme = Colors[colorScheme ?? "light"];

  return (
    <View
      style={[
        styles.infoRow,
        { borderBottomColor: theme.border },
        isLast && styles.infoRowLast,
      ]}
    >
      <ThemedText style={styles.infoLabel} type="small">
        {label}
      </ThemedText>
      <ThemedText style={styles.infoValue} type="smallSemiBold">
        {value}
      </ThemedText>
    </View>
  );
};

const styles = StyleSheet.create({
  infoRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    paddingVertical: 14,
    borderBottomWidth: 1,
  },
  infoRowLast: {
    borderBottomWidth: 0,
  },
  infoLabel: {
    flex: 1,
  },
  infoValue: {
    flexShrink: 1,
    textAlign: "right",
    fontWeight: "700",
  },
});

export default InfoRow;
